/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react';
import { StyledCarousel, StyledSlide, StyledSlides } from './Carousel.style';
import { carouselItems } from './CarouselItem/CarouselItem';
export const CarouselItems = (props) => {
    return (React.createElement(React.Fragment, null, carouselItems.map((item, index) => (React.createElement(StyledSlide, { key: index }, item.content(props))))));
};
export const Carousel = ({ children }) => {
    return (React.createElement(StyledCarousel, { "data-qa": "carousel" },
        React.createElement(StyledSlides, null, children)));
};
